import store from "../store";
import {errorShow, errorHide} from "../actions/errorActions";

const errorUtils = {
	// dispatch show error message, then dispatch error hide
	dispatchErrorWithTimeout: (message) => {
		store.dispatch(errorShow(message));
		setTimeout(function() {
			store.dispatch(errorHide());
		}, 4500);
	}
};

export default errorUtils;


// WEBPACK FOOTER //
// ./src/utils/errorUtils.js